// extracted by mini-css-extract-plugin
var _1 = "EmailVerificationStatusPopup_content__hpq3n";
var _2 = "EmailVerificationStatusPopup_details__IAXjm";
var _3 = "EmailVerificationStatusPopup_title__6cjH5";
export { _1 as "content", _2 as "details", _3 as "title" }
